import type { ActionsUnion } from '@kotify/rehelpers/reduxUtils';

import {
  flagCloseDialogs as sliceFlagCloseDialogs,
  loadFlagsSuccess as sliceLoadFlagsSuccess,
} from './slice';
import type { Flag } from './types';

export const loadFlagsSuccess = (flags: Flag[]) => sliceLoadFlagsSuccess(flags);
export const flagCloseDialogs = () => sliceFlagCloseDialogs();

export const Actions = {
  loadFlagsSuccess,
  flagCloseDialogs,
} as const;

export type Actions = ActionsUnion<typeof Actions>;
